module.exports = __webpack_public_path__ + "img/Logo_HospNckuD6.35647c20.png";